<template>
  <div class="app-container">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>订单编号：</span>
        <el-input
          v-model="search.orderNum"
          placeholder="请输入订单编号"
        ></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span>订单状态：</span>
        <el-select
          v-model="search.orderState"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in OrderStateTypeEnum"
            :key="item.enumCode"
            :label="item.description"
            :value="item.enumCode"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>创建日期：</span>
        <el-date-picker
          v-model="search.activityTimeDataArr"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :disabled="isEdit"
          style="width: 100%"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="8" class="flex">
        <span>预约日期：</span>
        <el-date-picker
          v-model="search.expectedVisitTimeDataArr"
          type="datetimerange"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :disabled="isEdit"
          style="width: 100%"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="8" class="flex">
        <span>联系电话：</span>
        <el-input v-model="search.yddh" placeholder="请输入手机号"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>回收类目：</span>
        <el-select
          v-model="search.spid"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in goodsTypeList"
            :key="item.value"
            :label="item.spmc"
            :value="item.spid"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-col>
      <!--      <el-col :span="8" class="flex">-->
      <!--        <span>订单类型：</span>-->
      <!--        <el-select v-model="search.orderType" placeholder="请选择" clearable style="width:100%">-->
      <!--          <el-option v-for="item in orderTypeList" :key="item.value" :label="item.label" :value="item.value" style="width:100%">-->
      <!--          </el-option>-->
      <!--        </el-select>-->
      <!--      </el-col>-->
      <el-col :span="8" class="flex">
        <span>订单来源：</span>
        <el-select
          v-model="search.sourceNum"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in sourceList"
            :key="item.sourceNum"
            :label="item.sourceName"
            :value="item.sourceNum"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>省份：</span>
        <el-select
          v-model="search.sfen"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.sfid"
            :label="item.sfen"
            :value="item.sfen"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>城市：</span>
        <el-select
          v-model="search.cshi"
          placeholder="请选择"
          clearable
          style="width: 100%"
          :disabled="!search.sfen"
        >
          <el-option
            v-for="item in cityList"
            :key="item.ciid"
            :label="item.city"
            :value="item.city"
            style="width: 100%"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>预约时效：</span>
        <el-select
          v-model="search.bookingTimeliness"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
        <el-option
          v-for="item in reservationOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
        </el-select>
      </el-col>
      <!-- <el-col :span="8" class="flex"></el-col> -->
    </el-row>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="8" class="flex">
        <span>完工时效：</span>
        <el-select
          v-model="search.completionTimeliness"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in completedOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex">
        <span>售后工单号：</span>
        <el-input
          v-model="search.smsOrderNum"
          placeholder="请输入售后工单号"
        ></el-input>
      </el-col>
      <el-col :span="8" class="flex">
        <span>回收商：</span>
        <el-select
          v-model="search.partnershipIds"
          placeholder="请选择"
          clearable
          style="width: 100%"
          multiple
        >
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.partnerName"
            :value="item.partnershipId">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" class="flex"></el-col>
      <el-col :span="8" class="flex" style="justify-content: flex-end;">
        <el-button type="primary" size="medium" @click="searchDataBtnFun()"
          >查询</el-button
        >
        <el-button size="medium" @click="resetForm()">重置</el-button>
        <!-- <el-button size="medium" @click="exportDialogVisible = true">导出</el-button> -->
        <el-button size="medium" @click="exportDialogFun">导出</el-button>
      </el-col>
    </el-row>

    <SelfEleTable ref="checktableData" :tableColumns="tableColumns" :tableData="list" @selection-change="handleSelectionChange">
      <template #spmc="{ scope }">
        <div class="goodsStyle">
            <el-image
              style="width: 80px; height: 80px; margin-right: 20px"
              fit="cover"
              :src="scope.row.commodityImage"
              lazy
            ></el-image>
            <span>{{ scope.row.spmc }}</span>
          </div>
      </template>
      <template #createdDate="{ scope }">{{ scope.row.createdDate | formatDateTimeDefault }}</template>

      <template #partnerName="{ scope }">
        <div v-if="scope.row.partnerName">
          {{ scope.row.partnerName }}:{{ scope.row.recyclersOrderNo }}
        </div>
        <div v-if="scope.row.smsOrderNum && scope.row.recyclersOrderNo != scope.row.smsOrderNum ">
          SMS：{{ scope.row.smsOrderNum }}
        </div>
        <div v-if="scope.row.yxypOrderNum && scope.row.recyclersOrderNo != scope.row.yxypOrderNum ">
          有闲有品:{{ scope.row.yxypOrderNum }}
        </div>
        <div v-if="scope.row.yyzsOrderNum  && scope.row.recyclersOrderNo != scope.row.yyzsOrderNum ">
          源园再生:{{ scope.row.yyzsOrderNum }}
        </div>
        <div v-if="scope.row.hhsOrderNum && scope.row.recyclersOrderNo != scope.row.hhsOrderNum ">
          嗨回收:{{ scope.row.hhsOrderNum }}
        </div>
        <div v-if="scope.row.boolvOrderNum && scope.row.recyclersOrderNo != scope.row.boolvOrderNum ">
          爱博绿:{{ scope.row.boolvOrderNum }}
        </div>
      </template>
      <template #actions="{ scope }">
        <el-button type="text"  v-if="![2, 3].includes(scope.row.orderState)"  @click="openCustomerComplainDialog(scope.row)">
            客户申诉
          </el-button>
        <el-button
            type="text"
            v-if="
              scope.row.cshi === '珠海市' &&
              !scope.row.yxypOrderNum &&
              scope.row.orderState === '待取件'
            "
            @click="pushOrder(scope.row, 2)"
            >推单</el-button
          >
          <el-button type="text" @click="goEdit(scope.row.orderNum)"
            >编辑</el-button
          >
          <el-button type="text" @click="exportGood(3, scope.row.orderNum)"
            >导出</el-button
          >
          <el-button type="text" @click="delectUser(scope.row.orderNum)"
            >删除</el-button
          >
          <!-- 待派单，待预约，待取件可以一直派单 -->
          <!--待预约，待取件  可以一直预约-->
           <el-button type="text" v-if="(scope.row.orderState == 0 || scope.row.orderState == 1  ) && partnershipType == 2" @click="reserveOrder(scope.row)">预约</el-button>
           <el-button type="text" v-if="(scope.row.orderState == 0 || scope.row.orderState == 1 || scope.row.orderState == -1)  && partnershipType == 2" @click="dispatchOrder(scope.row)">派单</el-button>

          </template>
    </SelfEleTable>

    <div class="pagination-container" style="display: flex;justify-content: space-between;">
      <div>
        <el-select v-model="selectedOption" placeholder="请选择推送选项">
          <el-option
            v-for="option in options"
            :key="option.id"
            :label="`${option.partnerName}`"
            :value="option.partnershipId"
          />
        </el-select>
        <el-button type="primary" @click="PushOrderLish(selectedOption)" :disabled="!selectedOption">
          推送
        </el-button>
      </div>
      <div>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="search.pageNum"
          :page-size="search.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <div class="BTNList">
        <!-- <el-button type="primary" @click="PushOrderLish(1)"
          >SMS批量推送</el-button
        >
        <el-button type="primary" @click="PushOrderLish(4)"
          >嗨回收批量推送</el-button
        >
        <el-button type="primary" @click="PushOrderLish(3)"
          >源园再生批量推送</el-button
        >
        <el-button type="primary" @click="PushOrderLish(2)"
          >有闲有品批量推送</el-button
        >
        <el-button type="primary" @click="PushOrderLish(5)"
          >爱博绿批量推送</el-button
        > -->

    </div>
    <!-- <el-dialog title="订单导出" :visible.sync="exportDialogVisible" width="400px" top="32vh" center>
      <div>
        <span>温馨提示：</span>
        <div>每次只能导出一种类型订单</div>
        <div>请您选择导出的订单类型</div>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="exportGood(1)">普通订单</div>
        <div @click="exportGood(2)">网点订单</div>
      </div>
    </el-dialog> -->
    <ExportPropDialog ref="exportPropDialogRef" @confirm-export="confirmExport"></ExportPropDialog>
    <CustomerComplainDialog ref="customerComplainDialogRef" />
    <ReserveOrderDialog ref="reserveOrderDialogRef" @success="getList" />
    <DispatchOrderDialog ref="dispatchOrderDialogRef" @success="getList" />
  </div>
</template>

<script>
import SelfEleTable from '@/components/SelfEleTable'
import ExportPropDialog from "./components/ExportPropDialog.vue";
import CustomerComplainDialog from "./components/CustomerComplainDialog.vue";
import ReserveOrderDialog from "./components/ReserveOrderDialog.vue";
import DispatchOrderDialog from "./components/DispatchOrderDialog.vue";
import { forEach } from "shelljs/commands";
import enumMixin from "./enumMixin.js";
import { exportOrderAsync } from "@/api/order";
import { getManagementList } from "@/api/recoveryManagement";
import {
  getPartner,
  onTimeReservationRate,
  completionPunctualityRate,
  completionAndCancelRate,
  getMetricsDetailList,
  getNomalExportField,
  getNormalOrderMetricsDimensionMap,
  getBookingTimelinessEnum,
  getCompletionTimelinessEnum,
  doNormalOrderTotal
} from "@/api/oldForNew";

export default {
  name: "home",
  components: {
    SelfEleTable,
    ExportPropDialog,
    CustomerComplainDialog,
    ReserveOrderDialog,
    DispatchOrderDialog
  },
  mixins: [enumMixin],
  data() {
    return {
      tableColumns: [
        {
          type: 'selection',
          width: 55,
          selectable: this.selectable,
          fixed: 'left'
        },
        {
          prop: 'spmc',
          label: '回收商品',
          width: 180,
          fixed: 'left',
          slotScoped: 'spmc'
        },
        {
          prop:'orderNum',
          label: '订单编号',
          minWidth: 150
        },
        {
          prop:'userTypeStr',
          label: '订单类型',
          minWidth: 100
        },
        {
          prop:'orderStateStr',
          label: '订单状态',
          minWidth: 100
        },
        {
          prop:'createdDate',
          label: '下单时间',
          minWidth: 160,
          slotScoped:'createdDate'
        },
        {
          prop:'yddh',
          label: '联系电话',
          minWidth: 160
        },
        {
          prop:'partnerName',
          label: '合作方',
          minWidth: 200,
          slotScoped:'partnerName'
        },
        {
          prop:'bookingTimelinessName',
          label: '预约时效',
          minWidth: 160,
        },
        {
          prop:'completionTimelinessName',
          label: '完工时效',
          minWidth: 160,
        },
        {
          prop:'actions',
          label: '操作',
          fixed: 'right',
          width: 200,
          slotScoped:'actions'
        }
      ],
      list: [],
      search: {
        orderNum: "", //用户编号
        yddh: "", //注册手机号
        orderState: "", //用户状态：0冻结，1可用
        createtimeTo: "", //注册时间（结束）
        createtimeFrom: "", //注册时间（开始）
        pageSize: 10,
        spid: "",
        pageNum: 1,
        userType: 1,
        sourceNum: "",
        sfen: "",
        cshi: "",
        activityTimeDataArr: [], // 创建时间
        expectedVisitTimeDataArr: [], // 期望上门时间
        bookingTimeliness: '',//预约时效
        completionTimeliness: '',//完成时效
        smsOrderNum : "",//售后工单号
        partnershipIds: []
      },
      isEdit: false,
      listLoading: false,
      orderStateList: [
        {
          label: "待取件",
          value: "1",
        },
        {
          label: "已完成",
          value: "2",
        },
        {
          label: "已取消",
          value: "3",
        },
      ],
      goodsTypeList: [],
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [], // 所有未选中的id
      oldarr: [],
      arr: [],
      total: 0,
      exportDialogVisible: false,
      sourceList: [],
      provinceList: [],
      cityList: [],
      IdLish: [],
      selectedOption: null, // 默认不选择
      options: [],
      reservationOptions:[],
      completedOptions:[],
        partnershipType: null, //当前用户所属组织 1 子公司 2 第三方 3 总公司
      };
    },
  filters: {},
  async created() {
    // this.getList()
    this.getTblSplbDalei();
    this.getSourceList();
    this.getTblProvince();
    if (this.$route.query.params) {
      this.search = Object.assign(this.search, this.$route.query.params);
      setTimeout(() => {
        this.getList();
      }, 500);
    }
    this.getBookingTimelinessEnum();
    this.getCompletionTimelinessEnum();
     // 获取当前账号的组织类型
    this.partnershipType = JSON.parse(localStorage.getItem("partnershipType"));
  },
  methods: {
    selectable(row, index) {
      const hasOrderNum = row.orderNum;
      return hasOrderNum && row.orderStateStr === "待派单";
    },
    searchDataBtnFun() {
      this.search.pageNum = 1;
      this.getList();
    },
    PushOrderLish(type) {
      if (!this.IdLish.length) {
        this.$message.error("请勾选订单");
        return;
      }
      let params = {
        type: type,
        orderNums: this.IdLish,
      };
      this.HttpService.post(
        `/autoapp-default-server-recovery/api/tblRecycleOrder/pushOrderManually`,
        params
      ).then((res) => {
        if (res.statusCode === 200) {
          this.$message.success("推单成功");
          this.getList();
        }
      });
    },
    pushOrder(value, type) {
      console.log(value, "value");
      let arr = [];
      if (typeof value === "object") {
        arr.push(value.orderNum);
      } else {
      }
      let params = {
        type: type,
        orderNums: arr,
      };
      this.HttpService.post(
        `/autoapp-default-server-recovery/api/tblRecycleOrder/pushOrderManually`,
        params
      ).then((res) => {
        if (res.statusCode === 200) {
          this.$message.success("推单成功");
          this.getList();
        }
      });
    },
    handleSelectionChange(val) {
      this.IdLish = val.map((item) => item.orderNum); //批量单号
    },
    getTblCity() {
      this.search.cshi = "";
      return this.HttpService.get(
        `/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${this.search.sfen}`
      ).then((res) => {
        if (res.statusCode === 200) {
          this.cityList = res.data;
        }
      });
    },
    getTblProvince() {
      this.search.cshi = "";
      return this.HttpService.get(
        "/autoapp-default-server-recovery/api/tbl-province/getTblProvince"
      ).then((res) => {
        if (res.statusCode === 200) {
          this.provinceList = res.data;
        }
      });
    },
    getTblSplbDalei() {
      let parmas = {
        flag: 1,
      };
      return this.HttpService.get(
        "/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei",
        parmas
      ).then((res) => {
        if (res.statusCode === 200) {
          this.goodsTypeList = res.data;
        }
      });
    },
    // 订单来源字典
    getSourceList() {
      return this.HttpService.get(
        "/autoapp-default-server-recovery/api/tblRecycleSource/list"
      ).then((res) => {
        if (res.statusCode === 200) {
          console.log("getSourceList>>>", res.data);
          this.sourceList = res.data;
        }
      });
    },
    paramsData() {
      const {
        orderNum = '',
        yddh = '',
        orderState = '',
        activityTimeDataArr = [],
        expectedVisitTimeDataArr = [],
        spid = '',
        userType = 1,
        sourceNum = '',
        sfen = '',
        cshi = '',
        bookingTimeliness = '',//预约时效
        completionTimeliness = '',//完成时效
        smsOrderNum = '',
        partnershipIds = []
      } = this.search || {};

      const getTimeRangeValue = (arr, index) =>
        Array.isArray(arr) && arr.length > index ? arr[index] : '';

      return {
        sfen,
        cshi,
        orderNum,
        yddh,
        orderState,
        userType,
        createtimeFrom: getTimeRangeValue(activityTimeDataArr, 0),
        createtimeTo: getTimeRangeValue(activityTimeDataArr, 1),
        qwsmsjFrom: getTimeRangeValue(expectedVisitTimeDataArr, 0),
        qwsmsjTo: getTimeRangeValue(expectedVisitTimeDataArr, 1),
        spid,
        sourceNum,
        bookingTimeliness:bookingTimeliness? Number(bookingTimeliness): '',
        completionTimeliness: completionTimeliness? Number(completionTimeliness):  '',
        smsOrderNum,
        partnershipIds
      };
    },
    getList() {
      let params = {
        pageSize: this.search.pageSize,
        pageNum: this.search.pageNum,
      };
      this.list = [];
      this.listLoading = true;
      this.HttpService.post(
        "/autoapp-default-server-recovery/api/tblRecycleOrder/getOrderList",
        Object.assign(this.paramsData(), params)
      ).then((res) => {
        if (res.statusCode === 200) this.total = res.total;
        if (res.data.length === 0) {
          this.$dialog({
            title: "温馨提示",
            content: "未查询到结果!",
            footBtn: false,
            width: "20%",
            dialogType: "sighicon",
          });
        } else {
          this.arr = [];
          this.list = res.data.records;
          this.listLoading = false;
          // res.data.records.forEach(element => {
          //   let { spmc } = element
          //   let params = {
          //     objectName: spmc === "空调" ? 'order/goods_air_conditioner.png' : spmc === "电视" ? 'order/goods_television.png' : spmc === "电脑" ? 'order/goods_computer.png' : spmc === "冰箱" ? 'order/goods_refrigerator.png' : 'order/goods_washing_machine.png'
          //   }
          //   promiseArr.push(this.getImg(element,params.objectName));
          // });
          // Promise.all(promiseArr)
          // .then(value =>{
          //   console.log(value, "所有图片加载成功");
          //   this.list = this.arr.slice(0, this.search.pageSize);
          //   this.listLoading = false;
          // })
          // .catch(err => {
          //   console.log(err, "有图片加载失败");
          //   this.listLoading = false;
          // })
        }
      });
    },
    getImg(element, objectName) {
      return new Promise((resolve, reject) => {
        this.axios({
          url:
            process.env.BASE_API +
            `/autoapp-default-server-recovery/api/OSS/generatePresignedUrlStr?objectName=${objectName}`,
          method: "GET",
          headers: {
            // 设置请求头
            Authorization: this.$store.getters.token,
          },
        }).then((res) => {
          element.goodsImage = res.data.data;
          this.arr.push(element);
          resolve();
        });
      });
    },
    exportGood(type, id) {
      if (type === 1) {
        this.search.userType = 1;
        this.export();
      } else if (type === 2) {
        this.search.userType = 2;
        this.export();
      } else {
        let params = {
          orderNum: id,
          commodityNum: "",
        };
        this.global
          .exportExcel(
            `/autoapp-default-server-recovery/api/tblRecycleOrder/exportOrderById`,
            params,
            "订单明细表"
          )
          .catch((res) => {
            let blob = new Blob([res.response.data], {
              type: "application/json",
            });
            var blobReader = new Response(blob).json();
            blobReader.then((res) => {
              this.$message.error(res.message);
            });
          });
      }
    },
    // 导出弹框选择属性导出
    exportDialogFun() {
      this.$refs.exportPropDialogRef.openFun(1)
    },
    // 确认导出
    confirmExport () {
      this.exportNormalData()
    },
    // 导出普通->改成异步导出
    async exportNormalData() {
      let { statusCode, message } = await exportOrderAsync(this.paramsData());
      if (statusCode == 200) {
        this.$message.success("已提交导出任务，请前往下载中心查看");
      } else {
        this.$message.error(message);
      }
      // this.exportGood(1);
    },
    export() {
      let params = {
        pageSize: this.search.pageSize,
        pageNum: this.search.pageNum,
      };
      let title = this.search.userType === 1 ? "个人用户" : "企业用户";
      this.global
        .exportExcel(
          "/autoapp-default-server-recovery/api/tblRecycleOrder/exportOrder",
          Object.assign(this.paramsData(), params),
          `${title}明细表`
        )
        .catch((res) => {
          let blob = new Blob([res.response.data], {
            type: "application/json",
          });
          var blobReader = new Response(blob).json();
          blobReader.then((res) => {
            this.$message.error(res.message);
          });
        });
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      // this.oldarr = this.oldarr.concat(this.unSelectedIds)
      // this.unSelectedIds = [...new Set(this.oldarr)]
      this.getList();
    },
    resetForm(formName) {
      this.search = this.$options.data().search;
      this.getList()
    },
    delectUser(id) {
      this.$dialog({
        title: "温馨提示",
        content: "是否要删除，删除后不可以恢复！",
        cancel_buttton: "否",
        ok_buttton: "是",
        width: "400px",
        footBtn: "card",
        dialogType: "delete",
        onOk: () => {
          if (id)
            this.HttpService.post(
              `/autoapp-default-server-recovery/api/tblRecycleOrder/delOrder/${id}`
            ).then((res) => {
              if (res.statusCode === 200) this.$message.success("删除成功");
              this.getList();
            });
        },
        onCancel: () => {
          console.log("cancel");
        },
      });
    },
    goEdit(id) {
      this.$router.push({
        path: "/order/orderEdit",
        query: {
          id: id,
          params: this.paramsData(),
          type: "userOrder",
        },
      });
    },
    openCustomerComplainDialog(row){
      this.$refs.customerComplainDialogRef.openDialog(row.orderNum)
    },

    //获取预约时效枚举值
    async getBookingTimelinessEnum() {
      getBookingTimelinessEnum().then(res => {
        if (res.statusCode === 200) {
          // 数据格式转换
          this.reservationOptions = res.data.map(item => {
            const value = Object.keys(item)[0];
            const label = item[value];
            return { value, label };
          });
        }
      })
    },

    //获取完工时效枚举值
    async getCompletionTimelinessEnum() {
      getCompletionTimelinessEnum().then(res => {
        if (res.statusCode === 200) {
          // 数据格式转换
          this.completedOptions = res.data.map(item => {
            const value = Object.keys(item)[0];
            const label = item[value];
            return { value, label };
          });
        }
      })
    },
    getManagementList(){
      const params = {
        partnershipType: 2,
        pageNum: 1,
        pageSize: 999,
      };
      getManagementList(params).then(res => {
        if (res.statusCode === 200) {
          this.options = res.data;
        }
      })
    },
    // 预约订单
    reserveOrder(row) {
      this.$refs.reserveOrderDialogRef.open(row.orderNum)
    },
    //派单
    dispatchOrder(row) {
      this.$refs.dispatchOrderDialogRef.open(row)
    },
  },
  mounted() {
    this.getManagementList()
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.BTNList {
}
</style>



// WEBPACK FOOTER //
// src/views/order/orderGet.vue